import { render } from "./ProductUpsells.vue?vue&type=template&id=75d223f2&lang=pug"
import script from "./ProductUpsells.vue?vue&type=script&lang=js"
export * from "./ProductUpsells.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__